import { NavLink, useLocation } from "react-router-dom";
import { Link2, Archive, BarChart3, Settings, LogOut } from "lucide-react";
import SiftraBadge from "@/components/SiftraBadge";

export const Layout = ({ children, onLogout }) => {
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Builder", icon: Link2 },
    { path: "/archive", label: "Link Repository", icon: Archive },
    { path: "/dashboard", label: "Dashboard", icon: BarChart3 },
    { path: "/settings", label: "Settings", icon: Settings },
  ];

  return (
    <div className="flex min-h-screen" data-testid="main-layout">
      {/* Sidebar */}
      <aside className="w-64 border-r border-zinc-200 bg-white flex flex-col">
        {/* Logo */}
        <div className="p-6 border-b border-zinc-200">
          <h1 className="text-xl font-bold tracking-tight text-zinc-950" data-testid="app-logo">
            AGCO<span className="text-[#AE132A]"> UTM</span>
          </h1>
          <p className="text-xs text-zinc-500 mt-1 uppercase tracking-widest">
            Link Builder
          </p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-6" data-testid="sidebar-nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={`nav-link ${isActive ? "active" : ""}`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <Icon className="w-4 h-4" />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-zinc-200">
          <button
            onClick={onLogout}
            className="nav-link w-full justify-start hover:text-[#AE132A]"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 bg-zinc-50 overflow-auto">
        {children}
      </main>

      <SiftraBadge />
    </div>
  );
};

export default Layout;
